<template>
<v-container>
  <progress-dialog :visible="dialog">{{ $t('login.authenticating') }}</progress-dialog>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Login',
  data: () => ({
    dialog: true
  }),
  methods: {
    login() {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      this.$auth.signInWithRedirect(provider);
      this.$auth.getRedirectResult().then(result => {
        this.redirect();
      }).catch(function(error) {
        let errorCode = error.code;
        let errorMessage = error.message;
        let email = error.email;
        let credential = error.credential;
        console.log('ERROR', errorCode, errorMessage, email);
      });
    },
    redirect() {
      this.$router.replace(this.$route.query.redirect || '/');
    }
  },
  mounted() {
    let unsubscribe = this.$auth.onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        this.redirect();
      } else {
        this.login();
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue